import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cells',
    templateUrl: './cells.component.html',
    styleUrls: ['./cells.component.scss'],
    standalone: false // NOSONAR
})
export class CellsComponent {
  color: any

  params: any;
  displayGreen: boolean = false;
  displayPartialGreen: boolean = false;
  displayYellow: boolean = false;
  displayPartialYellow: boolean = false;
  displayRed: boolean = false;
  displayPartialRed: boolean = false;
  displayPartialBlack: boolean = false;
  displayGrey: boolean = false;

  constructor() { }

  agInit(params: any): void {
    this.params = params;
    const keys = [
      'am',
      'bu',
      'ecg',
      'fa',
      'fr',
      'hj',
      'ho',
      'ilj',
      'inj',
      'loh',
      'los',
      'lsa',
      'nht',
      'ot',
      'pd',
      'sop',
      'st',
      'swf',
      'tm',
    ];
    if (keys.includes(this.params.colDef.field)) {
      if (this.params.data[this.params.colDef.field] == 4){ this.color = 'Green';}                        // NOSONAR
      return;
    }
    const coding = [
      { code: 4, codeName: 'Green' },
      { code: 5, codeName: 'partial-green' },
      { code: 2, codeName: 'yellow' },
      { code: 3, codeName: 'partial-yellow' },
      { code: 0, codeName: 'red' },
      { code: 1, codeName: 'partial-red' },
      { code: 6, codeName: 'partial-grey' },
      { code: '0', codeName: 'grey-square' },]

    this.color = coding.find(p => p.code == this.params.data[this.params.colDef?.field])?.codeName;         // NOSONAR

  }

}